<div class="row">
  @if (formGroup.controls['lsacAccountNumber'].enabled) {
    <div class="col-12 col-md-4">
      <nsc-form-field-input
        idx="lsac_id"
        controlName="lsacAccountNumber"
        hint="Enter LSAC ID 'Lxxxxxxxx'"
        maxlength="9"
        placeholder="Enter {{ content.labelLsacAccountNumber }}"
        [group]="formGroup"
        prefixT="L"
      [mask]="masks.lsacAccountNumber"></nsc-form-field-input>
    </div>
  }

  <div class="col-12"></div>

  @if (formGroup.controls['aamcAccountNumber'].enabled) {
    <div class="col-12 col-md-4">
      <nsc-form-field-input
        idx="amcas_id"
        controlName="aamcAccountNumber"
        hint="(8 digits)"
        maxlength="8"
        placeholder="Enter {{ content.labelAamcAccountNumber }}"
        [group]="formGroup"
      [mask]="masks.aamcAccountNumber"></nsc-form-field-input>
    </div>
  }
  @if (formGroup.controls['amcasTranscriptIdNumber'].enabled) {
    <div class="col-12 col-md-4">
      <nsc-form-field-input
        idx="amcas_number"
        controlName="amcasTranscriptIdNumber"
        hint="(7-8 digits)"
        maxlength="8"
        placeholder="Enter {{ content.labelAmcasTranscriptIdNumber }}"
        [group]="formGroup"
      [mask]="masks.amcasTranscriptIdNumber"></nsc-form-field-input>
    </div>
  }

  <div class="col-12"></div>

  @if (formGroup.controls['casId'].enabled) {
    <div class="col-12 col-md-6 col-lg-4">
      <div class="row nsc-row--12">
        <div class="col">
          <nsc-form-field-input
            idx="cas_id"
            controlName="casId"
            maxlength="60"
            placeholder="Enter {{ content.labelCasId }}"
          [group]="formGroup"></nsc-form-field-input>
        </div>
        <div class="col-auto nsc-ts-help__icon">
          <span id="help_button_desc" class="cdk-visually-hidden">opens a dialog</span>
          <button
            type="button"
            mat-icon-button
            id="helpUboxIcon"
            aria-label="Help"
            aria-describedby="help_button_desc"
            (click)="openDialog()"
          >
            <mat-icon aria-hidden="true">help</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
</div>
